import { Center, Text, VStack } from "@chakra-ui/react";
import Page from "shared/components/layout/Page";
import PageContainer from "shared/components/layout/PageContainer";

export const AppMaintenance: React.FC = () => (
  <Page>
    <PageContainer>
      <Center w="100%" h="100%" data-ls-enabled={true} data-public={true}>
        <VStack
          alignItems="felx-start"
          spacing="48px"
          w="100%"
          maxW="1100px"
          mx="130px"
        >
          <VStack alignItems="flex-start" spacing="16px">
            <Text fontSize="48px" color="gray.700">
              Maybern is under maintenance
            </Text>
            <Text fontSize="16px" color="gray.500">
              We are currently performing maintenance on the platform. Please
              check back soon.
            </Text>
          </VStack>
        </VStack>
      </Center>
    </PageContainer>
  </Page>
);
